import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Typography
} from "@material-ui/core";
import api from "../../services/api";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";

const FlowBuilderAddFormModal = ({ open, onSave, onUpdate, data, close }) => {
  const [forms, setForms] = useState([]);
  const [selectedFormId, setSelectedFormId] = useState("");
  const [message, setMessage] = useState(i18n.t("flowBuilder.editor.nodes.form.defaultMessage") || "Por favor, completa el siguiente formulario: {link}");

  useEffect(() => {
    if (open) {
      fetchForms();
      if (data) {
        setSelectedFormId(data.data?.formId || "");
        setMessage(data.data?.message || i18n.t("flowBuilder.editor.nodes.form.defaultMessage") || "Por favor, completa el siguiente formulario: {link}");
      }
    }
  }, [open, data]);

  const fetchForms = async () => {
    try {
      const response = await api.get("/forms");
      setForms(response.data);
    } catch (err) {
      toast.error(i18n.t("flowBuilder.editor.nodes.form.errorLoad") || "Error al cargar los formularios");
    }
  };

  const handleSave = () => {
    if (!selectedFormId) {
      return toast.error(i18n.t("flowBuilder.editor.nodes.form.errorSelect") || "Por favor, selecciona un formulario");
    }

    const selectedForm = forms.find(f => f.id === selectedFormId);
    
    if (data && data.id) {
      onUpdate({
        ...data,
        data: {
          ...data.data,
          formId: selectedFormId,
          formSlug: selectedForm?.slug,
          formName: selectedForm?.name,
          message
        }
      });
    } else {
      onSave({
        formId: selectedFormId,
        formSlug: selectedForm?.slug,
        formName: selectedForm?.name,
        message
      });
    }
    close();
  };

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
      <DialogTitle>{i18n.t("flowBuilder.editor.nodes.form.configTitle") || "Configurar Formulario Dinámico"}</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="textSecondary" gutterBottom>{i18n.t("flowBuilder.editor.nodes.form.configDesc") || "El cliente recibirá un enlace para llenar el formulario en la web. Una vez enviado, el flujo continuará."}</Typography>
        <FormControl fullWidth variant="outlined" margin="normal">
          <InputLabel>{i18n.t("flowBuilder.editor.nodes.form.selectForm") || "Seleccionar Formulario"}</InputLabel>
          <Select
            value={selectedFormId}
            onChange={(e) => setSelectedFormId(e.target.value)}
            label={i18n.t("flowBuilder.editor.nodes.form.selectForm") || "Seleccionar Formulario"}
          >
            {forms.map(f => (
              <MenuItem key={f.id} value={f.id}>
                {f.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label={i18n.t("flowBuilder.editor.nodes.form.messageLabel") || "Mensaje para enviar (usa {link} para la URL)"}
          variant="outlined"
          fullWidth
          margin="normal"
          multiline
          rows={3}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} variant="outlined" style={{ borderColor: "#ff4d4f", color: "#ff4d4f", textTransform: "none", fontWeight: "bold", borderRadius: "8px" }}>{i18n.t("contactModal.buttons.cancel") || "Cancelar"}</Button>
        <Button  onClick={handleSave}  variant="contained" style={{ backgroundColor: "#7367F0", color: "#fff", textTransform: "none", fontWeight: "bold", borderRadius: "8px", boxShadow: "0 4px 14px 0 rgba(115, 103, 240, 0.39)" }}>{i18n.t("common.save") || "Guardar"}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderAddFormModal;
